<template>
	<article class="content-frame column fill">
        <div v-if="pollLogsStatus.loading" class="demo-3">
            <spinner></spinner>
        </div>
        <div v-if="!pollLogsStatus.loading">
            <table v-if="pollLogs && pollLogs.length">
                <thead>
                    <tr>
                        <th>Time</th>
                        <th>Success</th>
                        <th>Error</th>
                        <th>Status Code</th>
                        <th>Response Data</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="log in pollLogs" v-bind:key="log.id" :class="expandedLogId === log.id ? 'selected' : ''">
                        <td>{{ log.ts * 1000 | date('long_with_time') }}</td>
                        <td>{{ log.success ? '✅' : '❌' }}</td>
                        <td>{{ log.err ? log.err : '-' }}</td>
                        <td><a :href="`https://httpstatuses.com/${log.statusCode}`">{{ log.statusCode }}</a></td>
                        <td v-if="expandedLogId !== log.id">{{ log.dataPreview }}</td>
                        <td v-if="expandedLogId === log.id">
                            <vue-json-pretty
                            :showLine="true"
                            :showDoubleQuotes="true"
                            :showLength="true"
                            :deep="3"
                            :data="log.data">
                            </vue-json-pretty>
                        </td>
                        <td>
                            <button class="outline-btn" v-if="expandedLogId !== log.id" @click="expandRow(log.id)">Expand</button>
                            <button class="outline-btn" v-if="expandedLogId && expandedLogId === log.id" @click="collapseExpanded">Collapse</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="center">
                <h3>No logs. Check back later.</h3>
            </div>
        </div>
	</article>
</template>

<script>
    import Spinner from '../components/Spinner';
	import date from '../filters/date';
    import { mapGetters } from 'vuex';
    import VueJsonPretty from 'vue-json-pretty';

	export default {
		name: 'PollLogs',
		filters: {
            date
        },
		data(){
			return {
                expandedLogId: null
            };
		},
		components: {
            Spinner,
            VueJsonPretty
		},
		computed: {
			...mapGetters([
				'pollLogs',
				'pollLogsStatus',
			])
		},
		methods: {
            expandRow: function (logId) {
                this.expandedLogId = logId;
            },
            collapseExpanded: function () {
                this.expandedLogId = null;
            }
		},
		created() {
			this.$store.dispatch('POLL_LOGS_REQUEST', { pollId: this.$route.params.pollId });
		}
	};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .center {
        text-align: center;
    }

    .selected {
        background-color: #F8F8F8;
    }

    tbody > tr {
        vertical-align: top;
    }
</style>



// WEBPACK FOOTER //
// src/views/PollLogs.vue